import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

interface AvailableLanguage {
  id: string;
}

const availableLanguagesResource = createCollectionResource<AvailableLanguage>({
  name: 'availableLanguages',
  endpoint: 'v1/orgs/:orgId/configuration/available-languages',
  observerCreator: emptyObserverCreator,
});

export default availableLanguagesResource;
